import React, {Component} from 'react';
import './ServiceCard.css';
import ServiceImage from "../../../../../assets/img/home_card_img.png";
import Layer2 from "../../../../../assets/img/2layers.png";
import Layer4 from "../../../../../assets/img/4layers.png";
import Layer6 from "../../../../../assets/img/6layers.png";
import {FormattedMessage} from "react-intl";

class ServiceCard extends Component {

    render() {
        return (

            <div className="services-card">
               <div className="card-heading text-center">
                   <h4>{this.props.serviceCardHeading}</h4>
               </div>
                <div className="card-image text-center">
                    <img src={this.props.serviceCard === 1 ? Layer2 : this.props.serviceCard === 2 ? Layer4 : Layer6} alt="Service" className="service-card-image"/>
                </div>
                <div className="card-parameter-div">
                    <table className="card-table">
                        <tbody>
                        <tr>
                            <td>&#10004;</td>
                            <td><FormattedMessage id="app.home-content.pcb-service.service-card.layers"
                                                   defaultMessage="Layers"
                                                   description=""/></td>
                            <td>: {this.props.serviceParam.layer} <FormattedMessage id="app.home-content.pcb-service.service-layers"
                                                                                    defaultMessage=" layers"
                                                                                    description=""/></td>
                        </tr>
                        <tr>
                            <td>&#10004;</td>
                            <td><FormattedMessage id="app.home-content.pcb-service.service-card.time"
                                                  defaultMessage="Production Time"
                                                  description=""/></td>
                            <td>: {this.props.serviceParam.buildTime}<FormattedMessage id="app.home-content.pcb-service.service-time"
                                                                                       defaultMessage=" hours"
                                                                                       description=""/></td>
                        </tr>
                        <tr>
                            <td>&#10004;</td>
                            <td><FormattedMessage id="app.home-content.pcb-service.service-card.size"
                                                  defaultMessage="Size"
                                                  description=""/></td>
                            <td>: {this.props.serviceParam.dimensions}</td>
                        </tr>
                        <tr>
                            <td>&#10004;</td>
                            <td><FormattedMessage id="app.home-content.pcb-service.service-card.sheets"
                                                  defaultMessage="Sheets"
                                                  description=""/></td>
                            <td>: {this.props.serviceParam.sheets}<FormattedMessage id="app.home-content.pcb-service.service-sheets"
                                                                                    defaultMessage=" sheets"
                                                                                    description=""/></td>
                        </tr>
                        <tr>
                            <td>&#10004;</td>
                            <td><FormattedMessage id="app.home-content.pcb-service.service-card.thickness"
                                                  defaultMessage="Thickness"
                                                  description=""/></td>
                            <td>: {this.props.serviceParam.thickness}</td>
                        </tr>
                        <tr>
                            <td>&#10004;</td>
                            <td><FormattedMessage id="app.home-content.pcb-service.service-card.register"
                                                  defaultMessage="Register"
                                                  description=""/></td>
                            <td>: {this.props.serviceParam.color}</td>
                        </tr>
                        <tr>
                            <td>&#10004;</td>
                            <td><FormattedMessage id="app.home-content.pcb-service.service-card.surface"
                                                  defaultMessage="Surface Finish"
                                                  description=""/></td>
                            <td>: {this.props.serviceParam.surface}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="highlighted-area text-center">
                    <p className="span-text"> &#165; {this.props.total}/10pcs (&#165; {this.props.costPerItem}/1pcs)</p>
                </div>
                <div className="bottom-text pull-right">
                    &#8251; 輸入費用含む
                </div>
            </div>

        );
    }

}

export default ServiceCard;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/PCBService/ServiceCard/ServiceCard.js